(function (angular) {
    'use strict';
    angular.module('mobilezuz').directive('spProductPricingMethod',  function () {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                isCase: '=',
                product: '=',
                onToggle: '&?'
            },
            templateUrl: 'views/templates/sp-product-pricing-method.html',
            controller: ['$scope', function ($scope) {
                $scope.toggle = toggle;
                
                _init();

                function toggle(val, $event) {
                    if (val === 1) {
                       
                        $scope.isCase = false;
                    }
                    if (val === 2) {
                        
                        $scope.isCase = false;
                    }
                    if (val === 3) {
                        $scope.isCase = true;
                       
                    }

                    if($scope.onToggle){
                        setTimeout(function(){
                            $scope.onToggle();
                        },500);
                        
                    }
                    $event && $event.stopPropagation();
                }

                function _init() {
                    $scope.count = 0;
                    if ($scope.product.branch) {
                        if ($scope.product.branch.case && $scope.product.branch.regularPrice != $scope.product.branch.case.price || !$scope.product.branch.case) {
                            $scope.count++;
                        }
                        if ($scope.product.branch.case && !!$scope.product.branch.case.price) {
                            $scope.count++;
                        }
                    }
                }

                $scope.$watch('product', _init);
            }],
            controllerAs: 'productPricingMethod'
        };
    });
})(angular);